import styled from "styled-components";

export const StyledExtraContentContainer = styled.h2`
  margin: 75px;
  font-size: 20px;
`;
